import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Bus, MapPin, Clock, Users, Ticket, Star } from 'lucide-react';

const BusBookingPromo = () => {
  const navigate = useNavigate();

  const popularRoutes = [
    { from: 'Lusaka', to: 'Livingstone', duration: '6h', price: 'K250' },
    { from: 'Lusaka', to: 'Ndola', duration: '4h', price: 'K180' },
    { from: 'Lusaka', to: 'Kitwe', duration: '5h', price: 'K200' },
    { from: 'Ndola', to: 'Kasama', duration: '7h', price: 'K280' }
  ];

  return (
    <div className="py-16 px-4 bg-gradient-to-r from-blue-50 to-indigo-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-medium">
              <Bus className="h-4 w-4" />
              Bus Booking
            </div>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">
              Travel across Zambia
              <br />
              <span className="text-blue-600">by Bus</span>
            </h2>
            <p className="text-xl text-gray-600">
              Book intercity bus tickets to major destinations. Compare operators, 
              choose your seat, and travel comfortably.
            </p>
            
            {/* Features List */}
            <div className="grid grid-cols-2 gap-4">
              <div className="flex items-center gap-2 text-gray-700">
                <div className="p-2 bg-blue-100 rounded-lg">
                  <Ticket className="h-4 w-4 text-blue-600" />
                </div>
                <span className="text-sm">E-Tickets with QR</span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <div className="p-2 bg-blue-100 rounded-lg">
                  <MapPin className="h-4 w-4 text-blue-600" />
                </div>
                <span className="text-sm">Live Bus Tracking</span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <div className="p-2 bg-blue-100 rounded-lg">
                  <Users className="h-4 w-4 text-blue-600" />
                </div>
                <span className="text-sm">Group Bookings</span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <div className="p-2 bg-blue-100 rounded-lg">
                  <Star className="h-4 w-4 text-blue-600" />
                </div>
                <span className="text-sm">Verified Operators</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={() => navigate('/bus')}
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg font-semibold rounded-xl"
                data-testid="book-bus-btn"
              >
                <Bus className="mr-2 h-5 w-5" />
                Book Bus Tickets
              </Button>
              <Button
                variant="outline"
                onClick={() => navigate('/bus/operator/login')}
                className="px-8 py-6 text-lg font-semibold rounded-xl border-blue-300 text-blue-700 hover:bg-blue-50"
                data-testid="bus-operator-btn"
              >
                <Users className="mr-2 h-5 w-5" />
                Bus Operator Portal
              </Button>
            </div>
          </div>
          
          {/* Popular Routes */}
          <div className="hidden lg:block">
            <div className="bg-white rounded-2xl shadow-xl p-6 border border-blue-100">
              <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                <MapPin className="h-5 w-5 text-blue-600" />
                Popular Routes
              </h3>
              <div className="space-y-3">
                {popularRoutes.map((route, idx) => (
                  <div 
                    key={idx} 
                    className="flex items-center justify-between p-4 bg-gray-50 rounded-xl hover:bg-blue-50 transition-colors cursor-pointer"
                    onClick={() => navigate('/bus')}
                  >
                    <div className="flex items-center gap-4">
                      <div className="p-2 bg-blue-100 rounded-lg">
                        <Bus className="h-5 w-5 text-blue-600" />
                      </div>
                      <div>
                        <p className="font-medium text-gray-900">{route.from} → {route.to}</p>
                        <p className="text-sm text-gray-500 flex items-center gap-1">
                          <Clock className="h-3 w-3" />
                          {route.duration}
                        </p>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="font-bold text-blue-600">from {route.price}</p>
                      <p className="text-xs text-gray-500">per seat</p>
                    </div>
                  </div>
                ))}
              </div>
              <p className="text-center text-sm text-gray-500 mt-4">
                Multiple departures daily • All major bus operators
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusBookingPromo;
